import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-price-list-bus-co',
  templateUrl: './price-list-bus-co.component.html',
  styleUrls: ['./price-list-bus-co.component.css']
})
export class PriceListBusCoComponent implements OnInit {
    priceListId;

    businessCoNo;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.priceListId = this.stateService.getStateParams()['pricelist_id'];
        this.businessCoNo = this.stateService.getStateParams()['businessco_no'];
    }

    private async loadEdit() {
        if (!!this.priceListId && !!this.businessCoNo) {
            this.edit = (await this.datatask.Post(667, {
                pricelist_id: this.priceListId,
                businessco_no: this.businessCoNo
            }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(668, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    pricelist_id: string;
    businessco_no: string;
    access_ok: string;
    modify_ok: string;
    pricelist_name: string;
    company_name: string;
}
